import React from 'react'
import styles from './SegmentationBoxInfo.module.css'

type SegmentationBoxHeaderProps = {
  backgroundImage: string
  height: number
}

export const SegmentationBoxHeader = ({ backgroundImage, height }: SegmentationBoxHeaderProps) => {
  return (
    <div className={styles.header} style={{ backgroundImage: ` url(${backgroundImage})`, height: `${height}px` }}></div>
  )
}
